const Dashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>
      <p>
        Welcome to the admin dashboard. Here you can manage the application
        settings and view analytics.
      </p>
    </div>
  );
};

export default Dashboard;
